import React from 'react';
import { ButtonOption } from './ButtonOption';

export const ButtonOptionSecondary = (props) => {
  return <ButtonOption variant="secondary" {...props} />;
};

ButtonOptionSecondary.propTypes = ButtonOption.propTypes;
